<script lang="ts">
  import DialogueModal from "$components/+shared/Modal/DialogueModal.svelte";
  import PromptModal from "$components/+shared/Modal/PromptModal.svelte";
  import type { WritableFolder } from "app/models/documents";
  import type { DocumentsStore } from "app/stores/documents";
  import KBCategory from "$components/knowledge-base/KnowledgeBaseNavigation/KBCategory.svelte";
  import KBSection from "$components/knowledge-base/KnowledgeBaseNavigation/KBSection.svelte";
  import { CategoryTypeEnum } from "@outverse-video/outverse-api-client-lib";
  import CategoryModal from "./CategoryModal.svelte";

  export let folder: WritableFolder;
  export let parentSection: WritableFolder | undefined = undefined;
  export let docs: DocumentsStore;
  export let hasDraggedEnteredParent = false;

  let isEditCategoryModalOpen = false;
  let isEditSectionModalOpen = false;
  let isDeleteModalOpen = false;

  $: folderKind = $folder.categoryType === CategoryTypeEnum.Category ? "category" : "section";
</script>

{#if $folder.categoryType === CategoryTypeEnum.Category}
  <KBCategory
    bind:isEditModalOpen={isEditCategoryModalOpen}
    bind:isDeleteModalOpen
    {folder}
    {parentSection}
    {docs}
    {hasDraggedEnteredParent}
  />
{:else}
  <KBSection bind:isEditModalOpen={isEditSectionModalOpen} bind:isDeleteModalOpen {folder} {docs} />
{/if}

<DialogueModal
  bind:open={isDeleteModalOpen}
  title={`Delete ${$folder.title}`}
  message={`Are you sure you want to delete this ${folderKind}?`}
  confirmLabel={"Delete"}
  on:confirm={folder.delete}
  danger
/>

<PromptModal
  bind:open={isEditSectionModalOpen}
  title={$folder.uuid ? "Update Section" : "Create Section"}
  confirmLabel={$folder.uuid ? "Update" : "Create"}
  value={$folder.title}
  blankErrorMessage={"Please enter a name for the section"}
  on:submit={(e) => {
    $folder.title = e.detail.value;
    isEditSectionModalOpen = false;
  }}
/>

<CategoryModal
  bind:open={isEditCategoryModalOpen}
  title={$folder.uuid ? `Update Category` : `Create Category`}
  confirmLabel={$folder.uuid ? "Update" : "Create"}
  name={$folder.title}
  icon={$folder.icon}
  iconDark={$folder.iconDark}
  blankErrorMessage={`Please enter a name for the category`}
  on:submit={({ detail: { name, icon, iconDark } }) => {
    if ($folder.title !== name) {
      $folder.title = name;
    }

    if (icon !== $folder.icon) {
      $folder.icon = icon;
    }
    if (iconDark !== $folder.iconDark) {
      $folder.iconDark = iconDark;
    }
    isEditCategoryModalOpen = false;
  }}
/>
